module.exports = __webpack_public_path__ + "img/home-bg4-3.d2325ee5.png";